import { getApiUrl } from "@app/shared";
import { useSignalr } from "@known-as-bmf/react-signalr";
import { useEffect } from "react";
import { Subscription } from "rxjs";

// Keep in sync with ForwardedPortHub.WatchForwardedPorts / StopWatchingForwardedPorts in CoreApi
const WATCH_FORWARDED_PORTS_COMMAND = 'WatchForwardedPorts';
const STOP_WATCHING_FORWARDED_PORTS_COMMAND = 'StopWatchingForwardedPorts';
// Keep in sync with IForwardedPortStatusClient.ForwardedPortsChanged in CoreApi
const FORWARDED_PORTS_CHANGED_EVENT = 'ForwardedPortsChanged';

export function useForwardedPortsHub(deviceId: string | undefined, onChanged: () => void, unsubscribe?: boolean) {
    const { send, on } = useSignalr(getApiUrl(`/hubs/forwardedports`));

    useEffect(() => {
        if (!deviceId) return;
        send(WATCH_FORWARDED_PORTS_COMMAND, deviceId);
        return () => {
            send(STOP_WATCHING_FORWARDED_PORTS_COMMAND, deviceId);
        };
    }, [deviceId, send]);

    useEffect(() => {
        let sub: Subscription | undefined;

        if (!unsubscribe) {
            sub = on<string>(FORWARDED_PORTS_CHANGED_EVENT).subscribe(() => onChanged());
        }

        return () => {
            sub?.unsubscribe();
        };
    }, [on, unsubscribe, onChanged]);
}
